import { Switch } from 'src/design/atoms/Switch';
import { Textarea } from 'src/design/atoms/Textarea';
import React from 'react';
import { formatDate } from 'src/utils';
import { AttachmentDto } from 'src/api/FiretrolApiClient';
import {
  useSaveAttachmentComment,
  useUploadDailyPhoto,
} from 'src/api/queries/dailys/useDailyAttachmentMutations';
import { ImageUpload } from 'src/design/organisms/ImageUpload/ImageUpload';
import { IAttachmentChange } from 'src/design/organisms/attachments/attachmentTypes';
import { StepProps } from './types';
import { useResolveAttachmentUrl } from 'src/api/queries/attachments/useAttachmentMutations';

export interface PhotosStepProps extends StepProps {
  onAttachmentsChange: (
    files: AttachmentDto[],
    change: IAttachmentChange,
  ) => void;
}

export const PhotosStep: React.FC<PhotosStepProps> = ({
  values,
  setFieldValue,
  setFieldTouched,
  onAttachmentsChange,
}) => {
  const uploadPhoto = useUploadDailyPhoto();
  const downloadAttachment = useResolveAttachmentUrl();
  const saveComment = useSaveAttachmentComment();

  return (
    <>
      <Switch
        label={`No Images for ${formatDate(values.date)}`}
        checked={values.excludeImages}
        onChange={(event) => {
          setFieldValue('excludeImages', event.currentTarget.checked);
          setFieldTouched('excludeImages', true, false);
        }}
      />

      {values.excludeImages && (
        <Textarea
          label="Reason for exclusion "
          placeholder="Explain why images are excluded..."
          value={values.exclusionImagesReason || ''}
          onChange={(e) =>
            setFieldValue('exclusionImagesReason', e.target.value)
          }
          maxLength={1000}
          rows={3}
          mb="md"
        />
      )}

      {!values.excludeImages && (
        <ImageUpload
          files={values.attachment ?? []}
          onChange={onAttachmentsChange}
          uploadFile={(file) => uploadPhoto.mutateAsync(file)}
          downloadFile={(id) => downloadAttachment.mutateAsync(id)}
          onCommentSave={async (id, comment) => {
            await saveComment.mutateAsync({ id, comment });
          }}
        />
      )}
    </>
  );
};
